import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import "./style.css";

const HexReactDatePicker = ({
  value,
  onChange,
  className,
  maxDate,
  minDate,
  excludeDates,
}) => {
  return (
    <div className={`hex-react-date-picker ${className || ""}`}>
      <ReactDatePicker
        className={"react-picker full-width"}
        onChange={onChange}
        selected={value}
        inline
        minDate={minDate || new Date()}
        tod
        maxDate={maxDate || null}
        excludeDates={excludeDates || []}
      />
    </div>
  );
};

export default HexReactDatePicker;
